/**
 * Gets the user's preferred language from their browser settings
 * @returns {string} Language code (e.g., 'en', 'es', 'fr', 'de')
 */
export function getUserLanguage() {
  // Get the user's preferred language from browser
  const userLang = navigator.language || navigator.userLanguage;
  
  // Extract the primary language code (e.g., 'en' from 'en-US')
  const langCode = userLang.split('-')[0];
  
  // Return the language code
  return langCode;
}

/**
 * Maps browser language codes to Google Maps language codes
 * @param {string} browserLang - Browser language code (e.g., 'en', 'es')
 * @returns {string} Google Maps language code
 */
export function mapToGoogleMapsLanguage(browserLang) {
  const languageMap = {
    'en': 'en',    // English
    'es': 'es',    // Spanish
    'fr': 'fr',    // French
    'de': 'de',    // German
    'it': 'it',    // Italian
    'pt': 'pt',    // Portuguese
    'ru': 'ru',    // Russian
    'ja': 'ja',    // Japanese
    'ko': 'ko',    // Korean
    'zh': 'zh',    // Chinese
    'he': 'iw',    // Hebrew (Google uses 'iw' for Hebrew)
    'ar': 'ar',    // Arabic
    'hi': 'hi',    // Hindi
    'th': 'th',    // Thai
    'vi': 'vi',    // Vietnamese
  };
  
  // Return the mapped language or fallback to English
  return languageMap[browserLang] || 'en';
}

/**
 * Gets the complete Google Maps language parameter
 * @returns {string} Language parameter for Google Maps (e.g., '&hl=en')
 */
export function getGoogleMapsLanguageParam() {
  const userLang = getUserLanguage();
  const googleLang = mapToGoogleMapsLanguage(userLang);
  return `&hl=${googleLang}`;
}

